import { render, staticRenderFns } from "./unit-autocomplete.vue?vue&type=template&id=845a6b2a&scoped=true&"
import script from "./unit-autocomplete.vue?vue&type=script&lang=js&"
export * from "./unit-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./unit-autocomplete.vue?vue&type=style&index=0&id=845a6b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845a6b2a",
  null
  
)

export default component.exports